import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-cross-close',
  templateUrl: './cross-close.component.html',
  styleUrls: ['./cross-close.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CrossCloseComponent {}
